export default "__VITE_ASSET__Ci_YNhqZ__"